import { Link, useNavigate } from "react-router-dom";
import {
  Stack,
  Typography,
  Box,
  Grid,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Divider,
} from "@mui/material";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import { AccountCircleOutlined, Add } from "@mui/icons-material";
import { green } from "@mui/material/colors";
import { useState, useEffect } from "react";

import AlertContainer from "../../components/AlertContainer.js";
import { ReactComponent as IconTrash } from "../../images/iconTrash.svg";
import { cpfMask } from "../../utils/mask";
import { formatDate, formatDateISO8601 } from "../../utils/formatarData";
import { cpf as checkCPF } from "cpf-cnpj-validator";
import successIcon from "../../images/dialogs/success.png";
import api from "../../services/api";
import { getDadosRegistroPorCPF } from "../../services/getRegistroApi";
import InserirDadosRegistro from "./inserirDadosRegistro";
import { validarData } from "../../utils/validarData.js";
import { ufList } from "../../utils/ufList.js";
import { isEmail } from "../../utils/validacaoDadosPaciente.js";
import StepperCustom from "../../components/StepperCustom";
import ButtonGoBack from "../../components/Buttons/outlinedGoback.js";
import ModalDialogs from "../../components/ModalDialogs";

import { dadosIniciais } from "./dadosIniciais.js";
import {
  FieldAutocomplete,
  FieldDatePicker,
  FieldInputMask,
  FieldInputText,
  FieldSelect,
} from "../../components/Fields/index.js";
import dayjs from "dayjs";
import { getItemDecrypt } from "../../utils/cryptoData";

const steps = [
  { title: "Verificação" },
  { title: "Identificação" },
  { title: "Endereço" },
];

const styles = {
  title: {
    fontWeight: "600",
    fontSize: "26px",
    lineHeight: "35px",
    color: "#063F5E",
    margin: "32px 0px",
  },
  subtitle: {
    fontWeight: "500",
    fontFamily: "Nunito",
    fontSize: "22px",
    lineHeight: "30px",
    marginBottom: "5px",
    color: "#1E729F",
  },
  input: {
    border: "1px solid #1E729F !important",
    borderRadius: "5px",
  },
  diamond: {
    fill: "#1E729F",
  },
};

export default function CadastroPaciente() {
  const navigate = useNavigate();
  const [dataForm, setDataForm] = useState(dadosIniciais);
  const [isCepInvalid, setIsCepInvalid] = useState(false);
  const [cpfValido, setCpfValido] = useState(true);
  const [cpfExiste, setCpfExiste] = useState(false);
  const [cpfInfo, setCpfInfo] = useState();
  const [cnsValido, setCnsValido] = useState(true);
  const [emailValido, setEmailValido] = useState(true);
  const [sexoList, setSexoList] = useState([]);
  const [naturalidadeList, setNaturalidadeList] = useState([]);
  const [dataValida, setDataValida] = useState(true);
  const [racaList, setRacaList] = useState([]);
  const [estadoCivilList, setEstadoCivilList] = useState([]);
  const [religiaoList, setReligiaoList] = useState([]);
  const [profissaoList, setProfissaoList] = useState([]);
  const [escolaridadeList, setEscolaridadeList] = useState([]);
  const [lateralidadeList, setLateralidadeList] = useState([]);
  const [tipoTrabalhoList, setTipoTrabalhoList] = useState([]);
  const [condicaoAtualList, setCondicaoAtualList] = useState([]);
  const [idPaciente, setIdPaciente] = useState("");
  const [identidadeGeneroList, setIdentidadeGeneroList] = useState([]);
  const [textoModal, setTextoModal] = useState("");
  const [loading, setLoading] = useState(true);
  const [municipioList, setMunicipioList] = useState([]);

  const [step, setStep] = useState(0);

  const [openSucess, setOpenSucess] = useState(false);
  const [openError, setOpenError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      setIsLoading(true);
      await Promise.all([
        getDataLateralidadeList(),
        getDataEstadoCivilList(),
        getDataReligiaoList(),
        getDataProfissaoList(),
        getDataSexoList(),
        getDataRacaList(),
        getDataEscolaridadeList(),
        getDataNaturalidadeList(),
        getDataTipoTrabalhoList(),
        getDataCondicaoTrabalhoList(),
        getIdentidadeGeneroList(),
      ]);
    } catch (error) {
      console.error("An error occurred during data fetching:", error.message);
    } finally {
      setIsLoading(false);
    }
  };

  function handleSetDataForm(field, value) {
    setDataForm((prevState) => ({
      ...prevState,
      [field]: value,
    }));
  }

  async function preencheDadosRegistro(cpf) {
    try {
      const dadosPaciente = await getDadosRegistroPorCPF(cpf);

      const campos = {
        handleSetDataForm,
        handleEstado,
      };

      InserirDadosRegistro(dadosPaciente, campos);
    } catch {
      console.error("Error preencheDadosRegistro");
    }
  }

  const handleClose = () => {
    setOpenSucess(false);
    setOpenError(false);
    setCpfExiste(false);
  };

  async function getDataLateralidadeList() {
    const { data } = await api.get("/lateralidade/");
    setLateralidadeList(data.data);
  }

  async function getDataEstadoCivilList() {
    const { data } = await api.get("/estadocivil/");

    setEstadoCivilList(data.data);
  }

  async function getDataReligiaoList() {
    const { data } = await api.get("/religiao/");
    setReligiaoList(data.data);
  }

  async function getDataProfissaoList() {
    const { data } = await api.get("/cbo/");
    setProfissaoList(data.cbo);
  }

  async function getDataSexoList() {
    const { data } = await api.get("/sexo/");
    setSexoList(data.data);
  }

  async function getDataRacaList() {
    const { data } = await api.get("/racacor/");
    setRacaList(data.data);
  }

  async function getDataEscolaridadeList() {
    const { data } = await api.get("/escolaridade/");
    setEscolaridadeList(data.data);
  }

  async function getDataNaturalidadeList() {
    const { data } = await api.get("/pais/");
    setNaturalidadeList(data.paises);
  }

  async function getDataTipoTrabalhoList() {
    const { data } = await api.get("/tipoTrabalho/");
    setTipoTrabalhoList(data.data);
  }

  async function getDataCondicaoTrabalhoList() {
    const { data } = await api.get("/condicaoTrabalho/");
    setCondicaoAtualList(data.data);
  }

  async function getIdentidadeGeneroList() {
    const { data } = await api.get("/identidadegenero/");
    setIdentidadeGeneroList(data.data);
  }

  async function postDadosForm() {
    try {
      const form = {
        id_vinculo: getItemDecrypt("vinculo_ativo").id,
        user: {
          no_cpf: dataForm.cpf ? dataForm.cpf.replace(/\D/g, "") : null,
          no_cns: dataForm.cns ? dataForm.cns.replace(/\D/g, "") : null,
          co_documento_estrangeiro: null,
          no_nome_social_usuario: dataForm.nomeSocial,
          no_nome_usuario: dataForm.nome,
          no_nome_mae: dataForm.nomeMae,
          co_sexo_biologico: dataForm.sexo,
          co_identidade_genero: dataForm.identidadeGenero,
          no_outros_genero: null,
          co_orientacao_sexual: null,
          co_raca_cor: dataForm.raca,
          dt_nascimento: dataForm.dataNascimento,
          co_pais_origem: null,
          co_naturalidade: dataForm.naturalidade,
          co_estado_civil: dataForm.estadoCivil,
          no_email: dataForm.email,
          no_foto: null,
          co_cbo: dataForm.profissao,
        },
        patient: {
          co_lateralidade: dataForm.lateralidade,
          co_escolaridade: dataForm.escolaridade,
          co_religiao: dataForm.religiao,
          co_religiao_outros: null,
          co_tipo_trabalho: dataForm.tipoTrabalho,
          no_atividades_profissionais: dataForm.ultimasAtividades,
          co_condicao_atual: dataForm.condicaoAtual,
          no_tempo_condicao_atual: dataForm.condicaoAtual,
          co_municipio_nascimento: dataForm.municipioNascimento,
        },
        phones: {
          telefones: dataForm.telefones,
        },
        address: {
          no_logradouro: dataForm.logradouro,
          no_numero: dataForm.numero,
          no_bairro: dataForm.bairro,
          no_complemento: dataForm.complemento,
          no_cep: dataForm.cep,
          co_estado: ufList.find((item) => item.uf === dataForm.uf).codigo_uf,
          co_cidade: dataForm.ibge,
        },
      };

      const { data } = await api.post("/paciente/", form);

      setIdPaciente(data.patient.co_id);
      setOpenSucess(true);
    } catch (error) {
      alert("Ocorreu um erro no envio do formulário");
      console.error("Ocorreu um erro:", error.message);
    }
  }

  async function handleCpf(value) {
    const cpf_check = value.replace(/\D/g, "");

    setLoading(true);

    handleSetDataForm("cpf", cpfMask(value));
    setCpfValido(checkCPF.isValid(cpf_check));

    if (cpf_check.length === 11) {
      try {
        const data = await api.post("/cpfexiste/", {
          cpf: cpf_check,
        });

        if (data.data.paciente) {
          setCpfExiste(true);

          setCpfInfo(data.data);
        } else {
          preencheDadosRegistro(cpf_check);

          setCpfInfo(null);
        }
      } catch (error) {
        console.error(error.message);
      }
    }
    setLoading(false);
  }

  function handleCns(value) {
    if (value.includes("_")) {
      setCnsValido(false);
    } else {
      setCnsValido(true);
    }
    handleSetDataForm("cns", value);
  }

  function handleEmail(value) {
    setEmailValido(isEmail(value));
    handleSetDataForm("email", value);
  }

  function handleTempoTrabalho(value) {
    if (value?.toString().length <= 2) {
      handleSetDataForm("tempoTrabalho", value);
    }
  }

  async function handleEstado(uf_id) {
    handleSetDataForm("municipioNascimento", "");
    setMunicipioList([]);

    if (uf_id === undefined || uf_id === null) {
      handleSetDataForm("estadoNascimento", "");
      return;
    }

    try {
      handleSetDataForm("estadoNascimento", uf_id.codigo_uf);

      const { data } = await api.post("/city", {
        state_id: uf_id.codigo_uf,
      });

      data.unshift({ co_ibge: "", no_descricao: "Selecione" });

      setMunicipioList(data);
    } catch (error) {
      console.error("Ocorreu um erro:", error.message);
    }
  }

  function handleDataNascimento(value) {
    setDataValida(validarData(value));
    handleSetDataForm("dataNascimento", value);
  }

  const createPhoneForm = () => {
    setDataForm((prevState) => ({
      ...prevState,
      telefones: [
        ...prevState.telefones,
        { id: prevState.telefones.length + 1, telefone: "", nome: "" },
      ],
    }));
  };

  const deletePhone = (index) => {
    setDataForm((prevState) => ({
      ...prevState,
      telefones: prevState.telefones.filter((tel, index2) => index !== index2),
    }));
  };

  const updatePhone = (index, field, value) => {
    const updatedTelefones = [...dataForm.telefones];
    updatedTelefones[index] = {
      ...updatedTelefones[index],
      [field]: value,
    };
    return updatedTelefones;
  };

  function handleCep(value) {
    const cep = value.replace(/[^\d]/g, "");
    if (String(cep).length === 8) {
      fetchCep(cep);
    }
    handleSetDataForm("cep", value);
  }

  async function fetchCep(cod) {
    await fetch(`https://viacep.com.br/ws/${cod}/json/`)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.uf === null) {
          handleSetDataForm("uf", "");
          handleSetDataForm("bairro", "");
          handleSetDataForm("logradouro", "");
          handleSetDataForm("municipio", "");
          handleSetDataForm("ibge", "");
        } else {
          handleSetDataForm("uf", data.uf);
          handleSetDataForm("municipio", data.localidade);
          handleSetDataForm("bairro", data.bairro);
          handleSetDataForm("logradouro", data.logradouro);
          handleSetDataForm("ibge", data.ibge);
        }
      });
  }

  function nextStep(e) {
    e.preventDefault();
    if (step === 0) {
      if (!cpfValido) {
        setTextoModal("O CPF informado não é válido.");
        setOpenError(true);
        return;
      }

      if (!cnsValido) {
        setTextoModal("O CNS informado não é válido.");
        setOpenError(true);
        return;
      }

      if (cpfValido) {
        if (cpfInfo) {
          setCpfExiste(true);
        } else {
          setStep(step + 1);
        }
      }
    }
    if (step === 1) {
      if (
        dataForm.email !== undefined &&
        dataForm.nome !== undefined &&
        dataForm.nomeMae !== undefined &&
        dataForm.sexo !== undefined &&
        dataForm.dataNascimento !== undefined &&
        dataForm.naturalidade !== undefined &&
        dataForm.raca !== undefined &&
        dataForm.estadoCivil !== undefined &&
        dataForm.escolaridade !== undefined &&
        dataForm.profissao !== undefined &&
        dataForm.telefones !== undefined
      ) {
        setStep(step + 1);
      }
    }
    if (step === 2) {
      if (
        dataForm.cep !== "" &&
        dataForm.uf !== "" &&
        dataForm.municipio !== "" &&
        dataForm.bairro !== "" &&
        dataForm.logradouro !== "" &&
        dataForm.numero !== 0
      ) {
        postDadosForm();
      }
    }
  }

  function stepBack() {
    if (step === 0) {
    } else {
      setStep(step - 1);
    }
  }

  const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
      padding: theme.spacing(2),
      color: green,
    },
    "& .MuiDialogActions-root": {
      padding: theme.spacing(1),
    },
  }));

  function BootstrapDialogTitle(props) {
    const { children, onClose, bgcolor, ...other } = props;

    return (
      <DialogTitle
        sx={{ m: 0, p: 2, color: "white", background: bgcolor }}
        {...other}
      >
        {children}
        {onClose ? (
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: "white",
            }}
          >
            <CloseIcon />
          </IconButton>
        ) : null}
      </DialogTitle>
    );
  }

  BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
  };

  if (isLoading) return <></>;
  return (
    <Box
      component={"div"}
      width="100%"
      minWidth={{ xs: "100%", sm: "100%", md: "850px" }}
      maxWidth={{ xs: "100%", sm: "100%", md: "850px" }}
      paddingBottom="50px"
    >
      <ButtonGoBack />

      <Box component={"h3"} style={styles.title}>
        Cadastro de Paciente
      </Box>

      <Box sx={{ mb: 4 }}>
        <StepperCustom stepData={steps} currentStep={step} />
      </Box>

      <Box
        sx={{
          boxShadow: "0px 0px 5px 4px rgba(217,217,217,0.3)",
          padding: "24px",
        }}
      >
        <Box sx={{ marginBottom: "8px" }}>
          <Box style={styles.subtitle}>
            {step === 0 && <>Verificação de cadastro</>}
            {step === 1 && <>Dados pessoais do paciente</>}
            {step === 2 && <>Endereço do paciente</>}
          </Box>
        </Box>

        <AlertContainer />
        <form
          autoComplete="off"
          style={{ marginTop: "24px" }}
          onSubmit={nextStep}
        >
          {step === 0 && (
            <Stack
              gap={"24px 16px"}
              sx={{
                color: "#1E729F",
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
                boxSizing: "border-box !important",
              }}
            >
              <FieldInputText
                label="CPF"
                value={dataForm.cpf}
                setValue={handleCpf}
                error={!cpfValido}
                helperText={cpfValido ? "" : "Informe um cpf válido"}
                placeholder="000.000.000-00"
                required
              />
              <FieldInputMask
                mask="999 9999 9999 9999"
                label="CNS"
                value={dataForm.cns}
                setValue={handleCns}
                error={!cnsValido}
                helperText={cnsValido ? "" : "Informe um cns válido"}
                placeholder="000 0000 0000 0000"
                required
              />
            </Stack>
          )}
          {step === 1 && (
            <Stack gap={"24px 16px"} mt="24px">
              <FieldInputText
                label="Nome"
                value={dataForm.nome}
                setValue={(value) => handleSetDataForm("nome", value)}
                required
              />

              <FieldInputText
                label="Nome social"
                value={dataForm.nomeSocial}
                setValue={(value) => handleSetDataForm("nomeSocial", value)}
              />
              <FieldInputText
                label="Nome da mãe"
                value={dataForm.nomeMae}
                setValue={(value) => handleSetDataForm("nomeMae", value)}
                required
              />
              <FieldInputText
                label="E-mail"
                value={dataForm.email}
                setValue={handleEmail}
                required
                type="email"
                error={!emailValido}
                helperText={emailValido ? "" : "Informe um email válido"}
              />

              <Stack
                sx={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                  boxSizing: "border-box !important",
                  gap: "24px 16px",
                }}
              >
                <FieldDatePicker
                  label="Data de nascimento"
                  value={dataForm.dataNascimento}
                  setValue={(value) =>
                    handleDataNascimento(formatDateISO8601(value))
                  }
                  required
                  maxDate={dayjs(new Date())}
                  error={!dataValida}
                  helperText={dataValida ? "" : "Informe uma data válida"}
                />
                <FieldAutocomplete
                  label="Naturalidade"
                  disabled={false}
                  getOptionLabel={(option) => option.no_nome || ""}
                  options={naturalidadeList}
                  value={
                    naturalidadeList
                      ? naturalidadeList.find(
                          (option) => option.co_id === dataForm.naturalidade
                        )
                      : null
                  }
                  setValue={(event, newValue) => {
                    handleSetDataForm("naturalidade", newValue?.co_id ?? "");
                  }}
                  id="combo-box-demo"
                  disablePortal={true}
                  defaultValue={naturalidadeList[25]}
                  required
                />
                <FieldAutocomplete
                  label="Estado de nascimento"
                  disabled={dataForm.naturalidade !== 23}
                  getOptionLabel={(option) => option.unidade_federativa || ""}
                  options={ufList}
                  value={
                    ufList.find(
                      (option) => option.codigo_uf === dataForm.estadoNascimento
                    ) || null
                  }
                  setValue={(event, newValue) => {
                    handleEstado(newValue);
                  }}
                  disablePortal={true}
                  required
                  defaultValue={""}
                />

                <FieldAutocomplete
                  label="Município de nascimento"
                  disabled={
                    municipioList?.length === 0 || dataForm.naturalidade !== 23
                  }
                  getOptionLabel={(option) => option.no_descricao || ""}
                  options={municipioList}
                  value={
                    municipioList
                      ? municipioList.find(
                          (option) =>
                            option.co_ibge === dataForm.municipioNascimento
                        )
                      : null
                  }
                  setValue={(event, newValue) => {
                    handleSetDataForm(
                      "municipioNascimento",
                      newValue?.co_ibge ?? ""
                    );
                  }}
                  disablePortal={true}
                  required
                  defaultValue={""}
                />

                <FieldSelect
                  label="Sexo biológico"
                  value={dataForm.sexo}
                  setValue={(value) => handleSetDataForm("sexo", value)}
                  items={sexoList.map((c) => {
                    return { id: c.co_id, label: c.no_descricao };
                  })}
                  required
                />

                <FieldSelect
                  label="Raça/Cor"
                  value={dataForm.raca}
                  setValue={(value) => handleSetDataForm("raca", value)}
                  items={racaList.map((c) => {
                    return { id: c.co_id, label: c.no_descricao };
                  })}
                  required
                />

                <FieldSelect
                  label="Identidade de gênero"
                  value={dataForm.identidadeGenero}
                  setValue={(value) =>
                    handleSetDataForm("identidadeGenero", value)
                  }
                  items={identidadeGeneroList.map((c) => {
                    return { id: c.co_id, label: c.no_descricao };
                  })}
                />

                <FieldSelect
                  label="Estado civil"
                  value={dataForm.estadoCivil}
                  setValue={(value) => handleSetDataForm("estadoCivil", value)}
                  items={estadoCivilList.map((c) => {
                    return { id: c.co_id, label: c.no_descricao };
                  })}
                  required
                />
              </Stack>

              <FieldSelect
                label="Religião"
                value={dataForm.religiao}
                setValue={(value) => handleSetDataForm("religiao", value)}
                items={religiaoList.map((c) => {
                  return { id: c.co_id, label: c.no_descricao };
                })}
              />

              <Stack
                sx={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                  boxSizing: "border-box !important",
                  gap: "24px 16px",
                }}
              >
                <FieldSelect
                  label="Lateridade"
                  value={dataForm.lateralidade}
                  setValue={(value) => handleSetDataForm("lateralidade", value)}
                  items={lateralidadeList.map((c) => {
                    return { id: c.co_id, label: c.no_descricao };
                  })}
                />

                <FieldSelect
                  label="Escolaridade"
                  value={dataForm.escolaridade}
                  setValue={(value) => handleSetDataForm("escolaridade", value)}
                  items={escolaridadeList.map((c) => {
                    return { id: c.co_id, label: c.no_descricao };
                  })}
                  required
                />

                <FieldAutocomplete
                  freeSolo
                  label="Profissão"
                  // disabled={
                  //   municipioList?.length === 0 || dataForm.naturalidade !== 23
                  // }
                  getOptionLabel={(option) => option.no_descricao || ""}
                  options={profissaoList}
                  value={
                    profissaoList.find(
                      (option) => option.co_id === dataForm.profissao
                    ) || null
                  }
                  setValue={(event, newValue) => {
                    handleSetDataForm("profissao", newValue?.co_id ?? "");
                  }}
                  disablePortal
                  required
                  defaultValue={""}
                />

                <FieldSelect
                  label="Tipo de trabalho"
                  value={dataForm.tipoTrabalho}
                  setValue={(value) => handleSetDataForm("tipoTrabalho", value)}
                  items={tipoTrabalhoList.map((c) => {
                    return { id: c.co_id, label: c.no_descricao };
                  })}
                />
              </Stack>

              <FieldInputText
                label="Últimas atividades profissionais"
                value={dataForm.ultimasAtividades}
                setValue={(value) =>
                  handleSetDataForm("ultimasAtividades", value)
                }
              />

              <Stack
                sx={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                  boxSizing: "border-box !important",
                  gap: "24px 16px",
                }}
              >
                <FieldSelect
                  label="Condição Atual"
                  value={dataForm.condicaoAtual}
                  setValue={(value) =>
                    handleSetDataForm("condicaoAtual", value)
                  }
                  items={condicaoAtualList.map((c) => {
                    return { id: c.co_id, label: c.no_descricao };
                  })}
                />

                <FieldInputText
                  label="Há quanto tempo?"
                  value={dataForm.tempoTrabalho}
                  setValue={handleTempoTrabalho}
                  type="number"
                  placeholder="Digite quanto tempo em anos"
                />
              </Stack>

              <Box>
                <Box style={styles.subtitle}>Dados de contato</Box>
              </Box>

              {dataForm.telefones.map((tel, index) => {
                return (
                  <Box key={index}>
                    <Box sx={{ border: "1px solid #CCCCCC", p: 2 }}>
                      <Grid
                        container
                        direction="row"
                        alignItems="center"
                        justifyContent="space-between"
                        sx={{ padding: "0 1rem" }}
                      >
                        <Box
                          component={"span"}
                          sx={{
                            fontWeight: "600",
                            fontSize: "16px",
                            lineHeight: "22px",
                            color: "#1E729F",
                          }}
                        >
                          Contato {index + 1}
                        </Box>
                        <Box
                          component={"span"}
                          sx={{
                            fontWeight: "600",
                            fontSize: "16px",
                            lineHeight: "22px",
                            color: "#1E729F",
                          }}
                        >
                          Ação
                        </Box>
                      </Grid>
                    </Box>

                    <Stack
                      sx={{
                        background: "#D3E3EB !important",
                        p: 2,
                        "& div, label": { background: "#D3E3EB !important" },
                        "&  input": { background: "#fff !important" },
                        display: "grid",
                        gridTemplateColumns:
                          "repeat(auto-fit, minmax(240px, 1fr))",
                        boxSizing: "border-box !important",
                        gap: "24px 16px",
                      }}
                    >
                      <FieldInputMask
                        mask="(99) 99999-9999"
                        placeholder="(99) 99999-9999"
                        value={tel.telefone}
                        setValue={(value) => {
                          setDataForm((prevState) => ({
                            ...prevState,
                            telefones: updatePhone(index, "telefone", value),
                          }));
                        }}
                        label="Telefone"
                        error={tel.telefone.includes("_")}
                        helperText={
                          tel.telefone.includes("_")
                            ? "Informe um Telefone válido"
                            : ""
                        }
                        type={"tel"}
                        required
                      />

                      <FieldInputText
                        label="Nome"
                        value={tel.nome}
                        setValue={(value) => {
                          setDataForm((prevState) => ({
                            ...prevState,
                            telefones: updatePhone(index, "nome", value),
                          }));
                        }}
                        required
                        id={index.toString()}
                      />

                      {index === 0 ? (
                        <Stack></Stack>
                      ) : (
                        <Button
                          style={{ background: "none", border: "none" }}
                          onClick={() => deletePhone(index)}
                        >
                          <IconTrash />
                        </Button>
                      )}
                    </Stack>
                  </Box>
                );
              })}

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "0",
                }}
              >
                <Stack></Stack>
                <Button
                  onClick={createPhoneForm}
                  variant="outlined"
                  sx={{ margin: "0", textTransform: "none" }}
                >
                  <Add /> Adicionar contato
                </Button>
              </Box>
            </Stack>
          )}
          {step === 2 && (
            <Stack gap={"24px 16px"}>
              <Stack
                sx={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                  boxSizing: "border-box !important",
                  gap: "24px 16px",
                }}
              >
                <FieldInputMask
                  mask="99999-999"
                  placeholder="99999-999"
                  label="CEP"
                  value={dataForm.cep}
                  setValue={(value) => handleCep(value)}
                  error={isCepInvalid}
                  helperText={isCepInvalid ? "Informe um CEP válido" : ""}
                  onBlur={(event) => {
                    setIsCepInvalid(event.target.value.includes("_"));
                  }}
                  required
                />

                <FieldInputText
                  label="UF"
                  value={dataForm.uf}
                  setValue={(value) => handleSetDataForm("uf", value)}
                  required
                  disabled
                />
                <FieldInputText
                  label="Município"
                  value={dataForm.municipio}
                  setValue={(value) => handleSetDataForm("municipio", value)}
                  required
                  disabled
                />
                <FieldInputText
                  label="Bairro"
                  value={dataForm.bairro}
                  setValue={(value) => handleSetDataForm("bairro", value)}
                  required
                  disabled
                />
              </Stack>

              <FieldInputText
                label="Logradouro"
                value={dataForm.logradouro}
                setValue={(value) => handleSetDataForm("logradouro", value)}
              />

              <Stack
                sx={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                  boxSizing: "border-box !important",
                  gap: "24px 16px",
                }}
              >
                <FieldInputText
                  label="Número"
                  value={dataForm.numero}
                  setValue={(value) => handleSetDataForm("numero", value)}
                  required
                />
                <FieldInputText
                  label="Complemento"
                  value={dataForm.complemento}
                  setValue={(value) => handleSetDataForm("complemento", value)}
                />
              </Stack>
            </Stack>
          )}
          <Divider sx={{ margin: "24px 0px" }} />
          <Grid container direction="row" justifyContent="space-between">
            <Button onClick={stepBack} variant="outlined">
              {step === 0 && "Cancelar"}
              {step > 0 && "Voltar"}
            </Button>
            <Button variant="contained" type="submit">
              {step <= 1 && "Prosseguir"}
              {step === 2 && "Cadastrar"}
            </Button>
          </Grid>
        </form>
      </Box>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={openSucess}
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={handleClose}
          bgcolor="#3AB238"
        >
          Cadastro salvo
        </BootstrapDialogTitle>
        <DialogContent sx={{ m: 5 }}>
          <Stack
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <img src={successIcon} width={100} />
            <Typography fontSize={25} sx={{ color: "#3AB238" }} gutterBottom>
              Paciente cadastrado com sucesso
            </Typography>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="success"
            autoFocus
            onClick={handleClose}
          >
            {idPaciente ? (
              <Link
                to={"/pacientes/prontuario/" + idPaciente}
                className="bg-blue-900 hover:bg-blue-800 text-white px-3 md:px-4 py-2 rounded text-decoration-none"
              >
                Prontuário do Paciente
              </Link>
            ) : (
              <>
                <Link
                  to={"/pacientes/prontuario/"}
                  className="bg-blue-900 hover:bg-blue-800 text-white px-3 md:px-4 py-2 rounded text-decoration-none"
                >
                  Prontuário do Paciente
                </Link>
              </>
            )}
          </Button>
        </DialogActions>
      </BootstrapDialog>

      <ModalDialogs
        title="Esse CPF/CNS já foi cadastrado"
        onClose={handleClose}
        open={cpfExiste}
        body={
          <>
            {!loading && (
              <Stack>
                <Typography
                  fontSize={18}
                  color="gray"
                  gutterBottom
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: "bold",
                  }}
                >
                  <AccountCircleOutlined sx={{ marginRight: "8px" }} />
                  {cpfInfo?.paciente.nome}
                </Typography>
                <Typography fontSize={18} color="gray" gutterBottom>
                  CPF: {checkCPF.format(cpfInfo?.paciente.cpf)}
                </Typography>
                <Typography fontSize={18} color="gray" gutterBottom>
                  CNS: {cpfInfo?.paciente.cns}
                </Typography>
                <Typography
                  fontSize={12}
                  color="gray"
                  gutterBottom
                  sx={{ m: 1 }}
                >
                  Usuário cadastrado em{" "}
                  {formatDate(cpfInfo?.paciente.dataCadastro)} por{" "}
                  {cpfInfo?.cadastradoPor && (
                    <>
                      {cpfInfo?.cadastradoPor.nome} <br></br> (
                      {cpfInfo?.cadastradoPor?.perfil} -{" "}
                      {cpfInfo?.cadastradoPor?.estabelecimentoDeSaude})
                    </>
                  )}
                </Typography>
              </Stack>
            )}
          </>
        }
        secondaryButtonText="Voltar para home"
        onActionSecondary={handleClose}
        primaryButtonText={
          cpfInfo?.paciente.id ? "Visualizar prontuário do paciente" : ""
        }
        onActionPrimary={() =>
          navigate("/pacientes/prontuario/" + cpfInfo?.paciente.id)
        }
      />

      <ModalDialogs
        open={openError}
        onClose={handleClose}
        title="Dado inválido"
        body={textoModal}
        primaryButtonText="Voltar"
        onActionPrimary={handleClose}
        modalType="warning"
      />
    </Box>
  );
}
